import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../store/ApplicationState";
import { AuthHistoryDispatchTypes } from "../../../models/DispatchTypes/AllPatientRecord";
import { getAuthHistory } from "../../../actions/Authorization";
import AuthHistoryUI from "../Component/AuthHistory";
import { AuthAndEligibilityHistoryPayload } from "../../../models/Authorization";

const mapStateToProps = ({ authHistoryState }: ApplicationState) => ({
  authHistoryData: authHistoryState,
});

type DispatchTypes = AuthHistoryDispatchTypes;

const mapDispatchToProps = (
  dispatch: ThunkDispatch<
    ApplicationState,
    Record<string, never>,
    DispatchTypes
  >
) => {
  return {
    getAuthHistory: (payload: AuthAndEligibilityHistoryPayload) => {
      dispatch(getAuthHistory(payload));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AuthHistoryUI);
